// extracted by mini-css-extract-plugin
export var blog = "BlogItemsList-module--blog--2dhFN";
export var posts = "BlogItemsList-module--posts--3kUYe";